import React, { useMemo, useState } from 'react';

interface CarFilterChecklistProps {
  title: string;
  searchPlaceholder: string;
  options: string[];
  selected: string[];
  onChange: (next: string[]) => void;
  name: string;
}

export const CarFilterChecklist: React.FC<CarFilterChecklistProps> = ({
  title,
  searchPlaceholder,
  options,
  selected,
  onChange,
  name,
}) => {
  const [open, setOpen] = useState(true);
  const [query, setQuery] = useState('');
  const visible = useMemo(() => {
    const needle = query.trim().toLowerCase();
    if (!needle) return options;
    return options.filter((option) => option.toLowerCase().includes(needle));
  }, [options, query]);

  const isChecked = (value: string) =>
    selected.some((item) => item.toLowerCase() === value.toLowerCase());

  const toggle = (value: string) => {
    if (isChecked(value)) {
      onChange(selected.filter((item) => item.toLowerCase() !== value.toLowerCase()));
      return;
    }
    onChange([...selected, value]);
  };

  return (
    <div className="car-check-filter">
      <button
        type="button"
        className="car-check-filter-toggle"
        aria-expanded={open}
        onClick={() => setOpen((prev) => !prev)}
      >
        <span>{title}</span>
        <span aria-hidden="true">{open ? '−' : '+'}</span>
      </button>
      {open && (
        <div className="car-check-filter-body">
          <input
            type="search"
            className="car-check-filter-search"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={searchPlaceholder}
            aria-label={searchPlaceholder}
          />
          <div className="car-check-filter-list" role="group" aria-label={title}>
            {visible.length === 0 ? (
              <p className="car-check-filter-empty">No matching {title.toLowerCase()}s</p>
            ) : (
              visible.map((option) => (
                <label key={option} className="car-check-filter-option">
                  <input
                    type="checkbox"
                    name={name}
                    value={option}
                    checked={isChecked(option)}
                    onChange={() => toggle(option)}
                  />
                  <span>{option}</span>
                </label>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};
